import _ from 'lodash';
import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import {
  useTransition, animated, interpolate,
} from 'react-spring';

const Div = styled.div`
  margin: ${props => (props.theme.isPortrait ? '20px 0 0 -20px' : '-20px -24px 0 0')};
  max-width: ${props => (props.theme.isPortrait ? 'none' : '576px')};
  width: ${props => (props.theme.isPortrait ? 100 : 40)}vw;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
`;

const jump = 20;
const jhalf = x => x * jump * 0.5;

const Images = styled.div`
  position: relative;
  width: ${props => (props.theme.isPortrait ? 100 : 40)}vw;
  height: ${props => (props.theme.isPortrait ? 85 : 32)}vw;
  margin-top: ${props => (props.theme.isPortrait ? 0 : -25)}px;

  > img {
    width: ${props => (props.theme.isPortrait ? 90 : 39)}vw;
    position: absolute;
    &:nth-last-child(3) {
      top: ${jump * 2}px;
      left: 0;
    }
    &:nth-last-child(2) {
      top: ${jump}px;
      left: ${jump}px;
    }
    &:nth-last-child(1) {
      top: 0;
      left: ${jump * 2}px;
    }
  }
`;

const Ul = styled.ul`
  display: flex;
  flex-direction: row;
  width: ${props => (props.theme.isPortrait ? 80 : 40)}vw;
  justify-content: center;
  padding-left: 0;
  margin: ${props => (props.theme.isPortrait ? '-10px 0 0 0' : '20px 0')};
  z-index: 1000;
`;

const dotSize = 8;
const Li = styled.li`
  margin: 0 7px;
  display: inline-block;
  width: ${dotSize}px;
  height: ${dotSize}px;
  border-radius: ${dotSize}px;
  border: 0;
  background-color: ${props => (props.isCurrent ? 'black' : '#999')};
  cursor: pointer;
`;

export default function Preview() {
  const { ebook } = React.useContext(ThemeContext);
  const [pages, setPages] = React.useState([...ebook]);
  const [current, setCurrent] = React.useState(0);
  const transitions = useTransition(pages, item => item, {
    from: { x: 1, y: -1, o: 1 },
    enter: { x: 0, y: 0, o: 1 },
    update: { x: 0, y: 0, o: 1 },
    leave: { x: 1, y: -1, o: 0 },
    unique: true,
    reset: true,
    config: { duration: 300 },
  });

  function onClick(i) {
    return e => {
      e.preventDefault();
      if (current !== i) {
        const step = i - current;
        const arr = _.times(3, d => (step + d + 3) % 3).map(d => pages[d]);
        setPages(arr.slice(1));
        setCurrent(i);
        setTimeout(() => setPages(arr), 150);
      }
    };
  }

  return (
    <Div>
      <Images>
        {transitions.map(({ item, props: { x, y, o }, key }) => (
          <animated.img
            key={key}
            style={{
              transform: interpolate([x, y], (xv, yv) => `translate3d(${jhalf(xv)}px, ${jhalf(yv)}px, 0)`),
              opacity: o,
            }}
            src={item}
          />
        ))}
      </Images>
      <Ul>
        {ebook.map((page, i) => <Li key={page} onClick={onClick(i)} isCurrent={current === i} />)}
      </Ul>
    </Div>
  );
}
